import { render, staticRenderFns } from "./xuzhi.vue?vue&type=template&id=471168ee&scoped=true&"
import script from "./xuzhi.vue?vue&type=script&lang=js&"
export * from "./xuzhi.vue?vue&type=script&lang=js&"
import style0 from "./xuzhi.vue?vue&type=style&index=0&id=471168ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471168ee",
  null
  
)

export default component.exports